<template>
  <b-modal :active.sync="localSignInUpEbookModal" :width="640" scroll="keep">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          Sign in / Sign up
        </p>
        <a class="card-header-icon" @click="closeModal()">
          <span class="icon is-small">
          <i class="mdi mdi-close"></i>
          </span>
        </a>
      </header>
      <div class="card-content">
        <single-ebook-card-content/>
        <p>You need to sign in / sign up first</p>
        <a @click="goToSignIn">Sign In</a> or <a @click="goToSignUp">Sign Up</a>
      </div>
    </div>
    <footer class="modal-card-foot">
      <button v-if="internalEbook.amazonAffiliateUrl" class="button is-secondary" @click="clickOnAmazonLink()">
        <span>Learn More</span>
      </button>
    </footer>
  </b-modal>
</template>

<script>
import singleEbookCardContent from '@/components/single-ebook-card-content'

export default {
  name: 'signInUpModal',
  components: {
    singleEbookCardContent
  },
  data () {
    return {
      internalEbook: {},
      localSignInUpEbookModal: false
    }
  },
  methods: {
    clickOnAmazonLink () {
      this.$store.dispatch('updateEbookOnAmazonLinkClick')
    },
    closeModal () {
      this.localSignInUpEbookModal = false
    },
    goToSignIn () {
      this.$store.dispatch('closeSignInUpModal')
      this.$router.push('/signin')
    },
    goToSignUp () {
      this.$store.dispatch('closeSignInUpModal')
      this.$router.push('/signup')
    }
  },
  watch: {
    getEbook (value) {
      this.internalEbook = value
    },
    localSignInUpEbookModal (value) {
      if (!value) {
        this.$store.dispatch('closeSignInUpModal')
      }
    },
    signInUpEbookModal (value) {
      this.localSignInUpEbookModal = value
    }
  },
  computed: {
    getEbook () {
      return this.$store.getters.getEbook
    },
    signInUpEbookModal () {
      return this.$store.getters.isSignInUpModal
    }
  }
}
</script>

<style>

</style>
